export default __webpack_public_path__ + "static/media/archive.9f7453d0.svg";